import { BASE_URL, getBaseAPIUrl, getSenseJsServerUrl } from '../config/environmentConfig';
import { Environments } from '../store/CheckoutContext';

export const parseJwt = (token: string) => {
  try {
    return JSON.parse(new Buffer(token.split('.')[1], 'base64').toString('binary'));
  } catch (e) {
    return null;
  }
};

const getSpreedlyToken = async (data: any) => {
  try {
    const url = `${BASE_URL.SPREEDLY_URL}?environment_key=${data?.spreedlyKey}`;
    const body = {
      payment_method: {
        retain: true,
        credit_card: {
          first_name: data?.billingInformation?.firstName,
          last_name: data?.billingInformation?.lastName,
          number: data?.paymentMethod?.cardNumber,
          verification_value: data?.paymentMethod?.cvv,
          month: data?.paymentMethod?.expirationMonth,
          year: data?.paymentMethod?.expirationYear,
          company: null,
          address1: null,
          address2: null,
          city: data?.billingAddress?.city ?? null,
          state: data?.billingAddress?.state ?? null,
          zip: data?.billingAddress?.zipcode ?? null,
          country: data?.billingAddress?.country ?? null,
          phone_number: data?.payer?.phone ?? null,
          shipping_address1: data?.shippingAddress?.addressLine1 ?? null,
          shipping_address2: data?.shippingAddress?.addressLine2 ?? null,
          shipping_city: data?.shippingAddress?.city ?? null,
          shipping_state: data?.shippingAddress?.state ?? null,
          shipping_zip: data?.shippingAddress?.zipcode ?? null,
          shipping_country: data?.shippingAddress?.ccountry ?? null,
          shipping_phone_number: data?.shippingAddress?.phone ?? null,
        },
        email: null,
        retained: true,
      },
      email: null,
      allow_blank_name: false,
      allow_expired_date: false,
      allow_blank_date: false,
      eligible_for_card_updater: false,
      metadata: null,
    };

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    };

    // @ts-ignore
    const response = await fetch(url, options).then(res => res.json());

    return response;
  } catch (error) {
    console.log('Get Spreedly token error');
  }
};

const getConfiguration = async (environment: Environments, mid: string, siteId: string) => {
  try {
    // const url = `${getSenseJsServerUrl(environment)}configuration/${mid}`;
    const url = `${getBaseAPIUrl(environment, 'configuration')}/${mid}/widget?siteId=${siteId}`;

    const options = {
      method: 'GET',
      // mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    };

    // @ts-ignore
    const response = await fetch(url, options).then(res => res.json());

    return response;
  } catch (e) {
    console.log('Get API Client error', e);
  }
};

const getClientToken = async (body: any, environment: Environments, name: string) => {
  try {
    const url = getBaseAPIUrl(environment, 'auth');

    const options = {
      method: 'POST',
      // mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      body: JSON.stringify(body),
    };

    // @ts-ignore
    const response = await fetch(url, options).then(res => res.json());

    return response;
  } catch (e) {
    console.log('Get API Client error');
  }
};

const cardTokenization = async (data: any, environment: Environments) => {
  console.log('cardTokenization', data);
  try {
    const configuration = await getConfiguration(environment, data?.mid, data?.siteId);

    if (configuration.siteId) {
      data.siteId = configuration.siteId;
    }
    // const url = getBaseAPIUrl(environment, 'auth');
    // const url = `https://4m8uwcypoc.execute-api.us-east-1.amazonaws.com/v1/payments/PaymentInstruments/tokenize?mid=${data?.mid}&environment=${configuration?.data?.TokenizationPublicKey}`;
    const url = `${getBaseAPIUrl(environment, 'tokenize')}/tokenize?mid=${data?.mid}&environment=${
      configuration?.tokenizationPublicKey
    }`;
    const body = {
      payment_method: {
        credit_card: {
          number: data.paymentMethod.cardNumber,
          month: data.paymentMethod.expirationMonth,
          year: data.paymentMethod.expirationYear,
          first_name: data.billingInformation.firstName,
          last_name: data.billingInformation.lastName,
          verification_value: data.paymentMethod.cvv,
          address1: data.billingInformation.addressLine1,
          shipping_address1: data.billingInformation.addressLine1,
          address2: data.billingInformation.addressLine2,
          shipping_address2: data.billingInformation.addressLine2,
          city: data.billingInformation.city,
          shipping_city: data.billingInformation.city,
          zip: data.billingInformation.zipcode,
          shipping_zip: data.billingInformation.zipcode,
          state: data.billingInformation.state,
          shipping_state: data.billingInformation.state,
          country: data.billingInformation.country,
          shipping_country: data.billingInformation.country,
          phone_number: data.payer.phone,
          shipping_phone_number: data.payer.phone,
          // email: data.billingInformation.
        },
        sense_key: window.sessionStorage.getItem('fc_sk'),
        email: data.payer.email,
      },
    };

    if (data.DynamicDescriptor) {
      // @ts-ignore
      body.DynamicDescriptor = data.DynamicDescriptor;
    }
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    };

    // @ts-ignore
    const response = await fetch(url, options)
      .then(res => {
        return res.json();
      })
      .catch(err => console.log('tokenize-----', err, options));

    return response;
  } catch (e) {
    console.log('Get API Client error');
  }
};

export const eligibility = async (
  body: any,
  environment: Environments,
  name: string,
  callback?: (res: any) => void,
) => {
  try {
    const identity = await getClientToken(
      {
        appKey: body?.appKey,
        appSecret: body?.appSecret,
      },
      environment,
      name,
    );

    const tokenizationResponse = await cardTokenization(body, environment);

    // const spreedlyResponse = await getSpreedlyToken(body);
    const token = (identity as any)?.accessToken;

    const url = getBaseAPIUrl(environment, name);

    const newBody = { ...body };
    delete newBody.appKey;
    delete newBody.appSecret;
    delete newBody.spreedlyKey;

    const options = {
      method: 'POST',
      // mode: 'no-cors',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      body: JSON.stringify({
        ...newBody,
        paymentMethod: {
          ...newBody.paymentMethod,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          cardNumber: tokenizationResponse?.transaction?.payment_method.token,
        },
      }),
    };
    // @ts-ignore
    const response = await fetch(url, options).then(res => res.json());

    if (callback) {
      callback(response);
    }

    return response;
  } catch (e) {
    console.log('Get eligibility error');
  }
};
